import { VERSION } from './version'

class Api {
  baseUrl

  accessToken
  accountId

  constructor(accessToken, accountId) {
    this.accessToken = accessToken
    this.accountId = accountId
  }

  async get(path, args) {
    const options = {
      headers: Object.assign({}, this.defaultHeaders, args?.headers || {}),
    }
    const fetchResult = await fetch('//' + this.baseUrl + path, options)

    if (fetchResult.ok) {
      return this.processResponse(fetchResult.json())
    } else {
      return Promise.reject(fetchResult)
    }
  }

  async post(path, body, args) {
    const options = {
      headers: Object.assign(
        { 'Content-Type': 'application/json' },
        this.defaultHeaders,
        args?.headers || {}
      ),
      body: JSON.stringify(body),
      method: 'POST',
    }
    const fetchResult = await fetch('//' + this.baseUrl + path, options)

    return this.processResponse(fetchResult.json())
  }

  async patch(path, args) {
    const options = {
      headers: Object.assign({}, this.defaultHeaders, args?.headers || {}),
      method: 'PATCH',
    }
    const fetchResult = await fetch('//' + this.baseUrl + path, options)

    if (fetchResult.ok) {
      return this.processResponse(fetchResult.json())
    } else {
      return Promise.reject(fetchResult)
    }
  }

  async delete(path, args) {
    const options = {
      headers: Object.assign({}, this.defaultHeaders, args?.headers || {}),
      method: 'DELETE',
    }
    return fetch('//' + this.baseUrl + path, options)
  }

  async processResponse(json) {
    return new Promise((resolve) => {
      json.then((result) => {
        const response = result
        resolve(response)
      })
    })
  }
}

export class HarvestAppApi extends Api {
  baseUrl = import.meta.env.VITE_HARVESTAPP_V2_API_URL

  get defaultHeaders() {
    return {
      Accept: 'application/json',
      Authorization: `Bearer ${this.accessToken}`,
      'Harvest-Account-Id': this.accountId,
      'X-Harvest-Platform-Version': VERSION,
      'X-Local-Timezone-Offset': new Date().getTimezoneOffset().toString(),
    }
  }
}

export class HarvestIdApi extends Api {
  baseUrl = import.meta.env.VITE_HARVEST_ID_V2_API_URL

  get defaultHeaders() {
    return {
      Accept: 'application/json',
      Authorization: `Bearer ${this.accessToken}`,
      'X-Harvest-Platform-Version': VERSION,
    }
  }
}
